<template>
  <section>
    <div class="flex justify-between md:flex-row flex-col">
      <h6
        class="text-xl font-normal leading-normal mt-0 mb-2 text-gray-dark font-semibold py-2"
      >
        Sales
      </h6>
      <DateFilter
        :handleDateChange="handleDateChange"
        :handleDateFilterCategoryChange="handleDateFilterCategoryChange"
        :dateFilterCategory="dateFilterCategory"
        :monthOfMonthAndYear="monthOfMonthAndYear"
        monthOfMonthAndYearId="monthOfMonthAndYear"
        yearOfMonthAndYearId="yearOfMonthAndYear"
        yearId="year"
        startDateId="startDate"
        endDateId="endDate"
        :yearOfMonthAndYear="yearOfMonthAndYear"
        :year="year"
        :startDate="startDate"
        :endDate="endDate"
      />
    </div>
    <!-- <div class="mb-4">
        <select
          class="mt-1 block w-full pl-3 pr-10 py-2 text-base ring-gray-300 focus:outline-none hover:shadow-lg sm:text-sm rounded-md bg-white ring-1"
          v-model="historyType"
        >
          <option value="all">All</option>
          <option value="tips">Tips</option>
        </select>
      </div> -->
    <TableAlt :thead="tableHead">
      <tbody
        v-if="earnigsSalesData && earnigsSalesData.length"
        class="bg-white divide-y divide-gray-200"
      >
        <tr v-for="(list, index) in earnigsSalesData" :key="index">
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">
            {{ index + 1 }}
          </td>
          <td
            class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize"
          >
            {{ list.attendee_name }}
          </td>
          <td
            class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize"
          >
            {{ list.session_title }} {{ list.course_title }}
          </td>
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">
            ${{ intToFloat(list.total_amount, 2) }}
          </td>
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">
            {{ dateFormat(list.created_at) }}
          </td>
          <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark">
            <button
              @click="downloadInvoice(list.order_id, list.attendee_name)"
              class="havor:shadow-lg focus:outline-none"
            >
              <img
                :src="require(`@/assets/img/download.webp`)"
                alt="Cross icon"
                class="rounded-lg w-6 h-6"
              />
            </button>
          </td>
        </tr>
      </tbody>
    </TableAlt>
    <div v-if="loadingStatus">
      <p class="text-center">Loading...</p>
    </div>
    <div v-else>
      <div v-if="!earnigsSalesData.length">
        <EmptyTable :description="'Try adjusting the filters to see more.'" />
      </div>
    </div>
    <Pagination
      v-if="earnigsSalesData && earnigsSalesData.length"
      :currentPage="currentPage"
      :handlePageChange="handlePageChange"
      :totalPages="totalPages"
    />
  </section>
</template>

<script>
import DateFilter from "@/components/DateFilter.vue";
import { TableAlt, Pagination, EmptyTable } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "EarningsSales",
  components: {
    DateFilter,
    TableAlt,
    Pagination,
    EmptyTable,
  },
  data() {
    return {
      tableHead: ["#", "Name", "Class Title", "Price", "Date" , "Download"],
      dateFilterCategory: "month",
      monthOfMonthAndYear: "",
      year: "selectyear",
      startDate: "",
      endDate: "",
      earnigsSalesData: [],
      historyType: "all",
      currentPage: 1,
      totalPages: 0,
    };
  },
  computed: {
    ...mapGetters(["trainerOrderList"]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions(["postTrainerOrderList", "getTrainerOrderInvoice"]),

    handleDateFilterCategoryChange(event) {
      this.dateFilterCategory = event.target.value;
    },

    async handleDateChange(event) {
      let startDate = null;
      let endDate = null;
      if (event.target.id === "startDate") {
        startDate = event.target.value;
        endDate = this.endDate;
      } else if (event.target.id === "endDate") {
        endDate = event.target.value;
        startDate = this.startDate;
      } else if (event.target.id === "monthOfMonthAndYear") {
        const month = Number(event.target.value);
        const year = this.yearOfMonthAndYear;
        this.monthOfMonthAndYear = month;

        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "yearOfMonthAndYear") {
        const year = Number(event.target.value);
        const month = this.monthOfMonthAndYear;
        this.yearOfMonthAndYear = year;
        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "year") {
        const year = Number(event.target.value);
        this.year = year;
        startDate = moment(new Date(year, 0, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, 12, 0)).format("YYYY-MM-DD");
      }
      this.startDate = startDate;
      this.endDate = endDate;

      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: startDate,
        end_date: endDate,
      };
      const query = {
        page: 1,
      };
      this.earnigsSalesData = [];
      this.currentPage = 1;
      await this.postTrainerOrderList({ payload, query });
      this.earnigsSalesData =
        this.trainerOrderList && this.trainerOrderList.data;
      this.totalPages = this.trainerOrderList.last_page;
    },

    async downloadInvoice(id, label) {
      await this.getTrainerOrderInvoice({ id: id, label: label });
    },

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: this.startDate,
        end_date: this.endDate,
      };
      this.earnigsSalesData = [];
      await this.postTrainerOrderList({ payload, query });
      this.earnigsSalesData =
        this.trainerOrderList && this.trainerOrderList.data;
    },
  },
  async created() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    const startDate = moment(new Date(currentYear, currentMonth, 1)).format(
      "YYYY-MM-DD"
    );
    const endDate = moment(new Date(currentYear, currentMonth + 1, 0)).format(
      "YYYY-MM-DD"
    );
    this.yearOfMonthAndYear = currentYear;
    this.monthOfMonthAndYear = currentMonth;
    this.startDate = startDate;
    this.endDate = endDate;

    const payload = {
      filter_type: "month",
      start_date: startDate,
      end_date: endDate,
    };
    const query = {
      page: this.currentPage,
    };
    await this.postTrainerOrderList({ payload, query });
    this.earnigsSalesData = this.trainerOrderList && this.trainerOrderList.data;
    this.totalPages = this.trainerOrderList && this.trainerOrderList.last_page;
  },
};
</script>